<div class="ext-status-page">

  <!-- Header -->
  <div class="ext-status-header">
    <div class="ext-status-title">
      <i class="material-icons">phone_in_talk</i>
      <div>
        <h5>Extension Status</h5>
        <span class="page-sub" *ngIf="lastRefreshed">
          Last updated {{ lastRefreshed | date:'h:mm:ss a' }} &nbsp;·&nbsp; auto-refresh every 30s
        </span>
      </div>
    </div>
    <div class="header-actions">
      <button class="action-btn action-btn-accent" (click)="load()" [disabled]="loading">
        <i class="material-icons">refresh</i> Refresh
      </button>
    </div>
  </div>

  <!-- Summary cards -->
  <div class="summary-row" *ngIf="!loading">
    <div class="summary-card summary-total">
      <div class="summary-num">{{ extensions.length }}</div>
      <div class="summary-lbl">Total Extensions</div>
    </div>
    <div class="summary-card summary-reserved">
      <div class="summary-num">{{ totalReserved }}</div>
      <div class="summary-lbl">In Use</div>
    </div>
    <div class="summary-card summary-available">
      <div class="summary-num">{{ totalAvailable }}</div>
      <div class="summary-lbl">Available</div>
    </div>
  </div>

  <!-- Release error banner -->
  <div *ngIf="releaseError" class="release-error">
    <i class="material-icons">error_outline</i>
    <span class="rel-msg">{{ releaseError }}</span>
    <button class="release-error-close" (click)="releaseError = ''">×</button>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="ext-loading">
    <i class="material-icons spin">sync</i> Loading…
  </div>

  <!-- Pools — rendered dynamically from API response -->
  <div class="pools-columns" *ngIf="!loading">

    <div *ngFor="let g of groupedPools" class="pool-section">
      <div class="pool-heading">
        <i class="material-icons">{{ g.icon }}</i>
        {{ g.poolLabel }} Extensions ({{ g.range }})
      </div>
      <div class="ext-grid">
        <div *ngFor="let e of g.exts" class="ext-row" [class.ext-row-reserved]="e.status === 'RESERVED'">

          <div class="ext-number">
            <i class="material-icons ext-icon">{{ e.status === 'RESERVED' ? 'phone_in_talk' : 'phone' }}</i>
            <span>{{ e.extensionNumber }}</span>
          </div>

          <div class="ext-badge-wrap">
            <span class="ext-badge"
                  [class.badge-reserved]="e.status === 'RESERVED'"
                  [class.badge-available]="e.status === 'AVAILABLE'">
              <span class="badge-text">{{ e.status === 'RESERVED' ? 'In Use' : 'Available' }}</span>
            </span>
          </div>

          <div class="ext-user" *ngIf="e.status === 'RESERVED'">
            <div class="user-avatar" [ngClass]="g.avatarClass">{{ initials(e.reservedByUserName) }}</div>
            <div class="user-info">
              <div class="user-name">{{ e.reservedByUserName }}</div>
              <div class="user-since">Since {{ reservedSince(e.reservedAt) }}</div>
            </div>
          </div>
          <div class="ext-user ext-user-empty" *ngIf="e.status !== 'RESERVED'">—</div>

          <div class="ext-actions" *ngIf="isAdmin && e.status === 'RESERVED'">
            <button class="release-btn"
                    [class.releasing]="releasingExts.has(e.extensionNumber)"
                    [disabled]="releasingExts.has(e.extensionNumber)"
                    (click)="promptRelease(e)"
                    title="Force release this extension">
              <i class="material-icons">{{ releasingExts.has(e.extensionNumber) ? 'hourglass_empty' : 'lock_open' }}</i>
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- Empty state -->
    <div *ngIf="groupedPools.length === 0" class="ext-empty">
      <i class="material-icons">info_outline</i> No extensions configured yet.
    </div>

  </div>

</div>

<!-- Force-release confirmation modal -->
<div class="modal-backdrop" *ngIf="confirmExt" (click)="cancelRelease()" (keydown.escape)="cancelRelease()">
  <div class="modal-card" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
    <div class="modal-icon"><i class="material-icons">lock_open</i></div>
    <h6 class="modal-title">Force Release Extension</h6>
    <p class="modal-body">
      Release extension <strong>{{ confirmExt.extensionNumber }}</strong> currently held by
      <strong>{{ confirmExt.reservedByUserName }}</strong>?
    </p>
    <p class="modal-warn">This will disconnect their SIP session immediately.</p>
    <div class="modal-actions">
      <button class="modal-btn modal-btn-cancel" (click)="cancelRelease()">Cancel</button>
      <button class="modal-btn modal-btn-danger" (click)="confirmRelease()">
        <span class="modal-btn-danger-text">Force Release</span>
      </button>
    </div>
  </div>
</div>
